<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View an Induction</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <ng-container *ngIf="induction.name">
    <h6>Induction Name</h6>
    <p>{{ induction.name }}</p>
  </ng-container>

  <ng-container *ngIf="induction.description">
    <h6>Introduction</h6>
    <div [innerHTML]="induction.description | sanitizeHtml"></div>
  </ng-container>

</mat-dialog-content>
